"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3851],{

/***/ 58228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5434);
// import React, { useState, useRef, useEffect } from "react";
// import styles from "./FAQ.module.css";
// import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
// const FAQ = ({ faqs = [] }) => {
//   const [isExpanded, setIsExpanded] = useState({
//     state: false,
//     index: null,
//   });
//   const ref = useRef({});
//   const contentRefsLeft = faqs.slice(faqs.length / 2).map(() => useRef(null));
//   const contentRefsRight = faqs.slice(0, faqs.length / 2).map(() => useRef(null));
//   useEffect(() => {
//     // Dynamically set the height of each content based on its actual height
//     contentRefsLeft.forEach((ref, index) => {
//       if (ref.current) {
//         ref.current.style.height =
//           isExpanded.index === index + faqs.length / 2 && isExpanded.state
//             ? `${ref.current.scrollHeight}px`
//             : "0px";
//       }
//     });
//     contentRefsRight.forEach((ref, index) => {
//       if (ref.current) {
//         ref.current.style.height =
//           isExpanded.index === index && isExpanded.state
//             ? `${ref.current.scrollHeight}px`
//             : "0px";
//       }
//     });
//   }, [isExpanded, faqs]);
//   return (
//     <div className="py-12">
//       <h4 className="text-2xl sm:text-4xl font-semibold capitalize text-center">
//         Frequently Asked Questions
//       </h4>
//       <div className="w-full mt-6 sm:mt-10 flex flex-col justify-center md:flex-row items-start flex-wrap">
//         <div className="w-full md:w-[48%] md:mr-2">
//           {faqs?.slice(faqs.length / 2).map((faq, i) => (
//             <div
//               key={i}
//               onClick={() => {
//                 setIsExpanded((prev) => ({
//                   state: prev.index === i + faqs.length / 2 ? !prev.state : true,
//                   index: i + faqs.length / 2,
//                 }));
//               }}
//               className={`faq-wrapper ${
//                 isExpanded.index === i + faqs.length / 2 && isExpanded.state && styles.fadeIn
//               } w-full mb-4 border rounded-lg px-4 py-3 cursor-pointer`}
//             >
//               <div className="flex flex-row items-center justify-between">
//                 <h2 className="text-base sm:text-lg font-semibold">
//                   {faq.title}
//                 </h2>
//                 <span className="ml-4 cursor-pointer hover:opacity-90">
//                   {isExpanded.index === i + faqs.length / 2 && isExpanded.state ? (
//                     <MdKeyboardArrowUp className="text-3xl" />
//                   ) : (
//                     <MdKeyboardArrowDown className="text-3xl" />
//                   )}
//                 </span>
//               </div>
//               <div
//                 ref={contentRefsLeft[i]}
//                 className={`text-sm md:text-base mt-2 overflow-hidden transition-height duration-300 ease-in-out`}
//               >
//                 {faq.desc}
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="w-full md:w-[48%] md:ml-2">
//           {faqs?.slice(0, faqs.length / 2).map((faq, i) => (
//             <div
//               key={i}
//               onClick={() => {
//                 setIsExpanded((prev) => ({
//                   state: prev.index === i ? !prev.state : true,
//                   index: i,
//                 }));
//               }}
//               className={`faq-wrapper ${
//                 isExpanded.index === i && isExpanded.state && styles.fadeIn
//               } w-full mb-4 border rounded-lg px-4 py-3 cursor-pointer`}
//             >
//               <div className="flex flex-row justify-between">
//                 <h2 className="text-base sm:text-lg font-semibold">
//                   {faq.title}
//                 </h2>
//                 <span className="ml-4  hover:opacity-90">
//                   {isExpanded.index === i && isExpanded.state ? (
//                     <MdKeyboardArrowUp className="text-3xl" />
//                   ) : (
//                     <MdKeyboardArrowDown className="text-3xl" />
//                   )}
//                 </span>
//               </div>
//               <div
//                 ref={contentRefsRight[i]}
//                 className={`text-sm md:text-base mt-2 overflow-hidden transition-height duration-300 ease-in-out`}
//               >
//                 {faq.desc}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };
// export default FAQ;


// import "./index.css";


const FAQ = (param)=>{
    let { faqs =[]  } = param;
    const [isExpanded, setIsExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        state: false,
        index: null
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "py-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "text-2xl sm:text-4xl font-semibold capitalize text-center",
                children: "Frequently Asked Questions"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full mt-6 sm:mt-10 flex flex-col md:flex-row items-start flex-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full md:w-[48%] md:mr-2",
                        children: faqs === null || faqs === void 0 ? void 0 : faqs.slice(faqs.length / 2).map((faq, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: ()=>{
                                    setIsExpanded((prev)=>({
                                            state: prev.index === faq.id ? !prev.state : true,
                                            index: faq.id
                                        }));
                                },
                                className: "".concat(isExpanded.index === faq.id && isExpanded.state && "fadeIn", " w-full mb-4 border rounded-lg p-4 cursor-pointer"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-base sm:text-lg font-semibold",
                                                children: faq.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ml-4 cursor-pointer hover:opacity-90",
                                                children: isExpanded.index === faq.id && isExpanded.state ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdKeyboardArrowUp */ .rWj, {
                                                    className: "text-3xl"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdKeyboardArrowDown */ .Ix0, {
                                                    className: "text-3xl"
                                                })
                                            })
                                        ]
                                    }),
                                    isExpanded.index === faq.id && isExpanded.state && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm md:text-base mt-2",
                                        children: faq.desc
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full md:w-[48%] md:ml-2",
                        children: faqs === null || faqs === void 0 ? void 0 : faqs.slice(0, faqs.length / 2).map((faq, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: ()=>{
                                    setIsExpanded((prev)=>({
                                            state: prev.index === faq.id ? !prev.state : true,
                                            index: faq.id
                                        }));
                                },
                                className: "faq-wrapper ".concat(isExpanded.index === faq.id && isExpanded.state && "fadeIn", " w-full mb-4 border rounded-lg p-4 cursor-pointer"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-row justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-base sm:text-lg font-semibold",
                                                children: faq.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ml-4 hover:opacity-90",
                                                children: isExpanded.index === faq.id && isExpanded.state ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdKeyboardArrowUp */ .rWj, {
                                                    className: "text-3xl"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdKeyboardArrowDown */ .Ix0, {
                                                    className: "text-3xl"
                                                })
                                            })
                                        ]
                                    }),
                                    isExpanded.index === faq.id && isExpanded.state && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm md:text-base mt-2",
                                        children: faq.desc
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ);


/***/ }),

/***/ 25085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_useDeviceSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66285);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var react_use_intercom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41608);








const INTERCOM_APP_ID = "jldyfmwj";
const SupportSec = (param)=>{
    let { refId  } = param;
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    let pathname = router.pathname;
    let [width] = (0,_utils_useDeviceSize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: refId,
        className: "py-12 flex flex-col justify-center items-center px-4 xxl:-mx-12",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-10 mb-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    className: "h-full",
                    width: 220,
                    height: 10,
                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/support/stars.png"),
                    alt: "",
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                className: "text-center text-3xl sm:text-5xl font-bold mb-4",
                children: [
                    "Award-winning support",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[#9C6CFF]",
                        children: "."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center text-base sm:text-xl",
                children: "Best-in-class support. We’re always here to help – here’s how to connect."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row mt-12 flex-wrap lg:flex-nowrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupportCard, {
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/support/live-chat-support.png"),
                        title: "Chat with Us",
                        description: "Ask a question right now.",
                        buttonText: "Start a chat",
                        buttonLink: "https://wa.me/message/MBQ5HUL53GQVK1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupportCard, {
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/support/support-email.png"),
                        title: "Email",
                        description: "Get in touch by email.",
                        buttonText: "Send an Email",
                        marginRight: width > 1024 ? "sm:mr-6" : "mr-0",
                        buttonLink: "mailto:support@boloforms.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupportCard, {
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/support/helpcenter.png"),
                        title: "Help center",
                        description: "In Depth Guides.",
                        buttonText: "Read articles",
                        buttonLink: (pathname === null || pathname === void 0 ? void 0 : pathname.includes("/timer-classroom")) ? "http://timer-docs.boloforms.com/" : "http://approval-docs.boloforms.com/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupportCard, {
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_6__.BASE_ASSETS_URL, "/support/book-time.png"),
                        title: "Google Meet",
                        description: "Guided support and Q&A.",
                        buttonText: "Book a time",
                        marginRight: "mr-0",
                        buttonLink: "https://calendly.com/boloforms/15min"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SupportSec);
const SupportCard = (param)=>{
    let { image , title ="Live Chat" , description ="Chat with us live 24/7" , buttonText ="Chat with us" , buttonLink ="#" , marginRight ="sm:mr-6"  } = param;
    const openLink = ()=>{
        if (title === "Chat with Us") {
            show();
        } else {
            window.open(buttonLink, "_self");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            boxShadow: "rgb(0 0 0 / 4%) 0 1px 0, rgb(0 0 0 / 5%) 0 2px 7px, rgb(0 0 0 / 6%) 0 12px 22px"
        },
        className: "w-full bg-white sm:w-[47%] lg:w-full p-8 ".concat(marginRight, " mb-6 rounded-xl flex flex-col justify-between"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: image,
                            className: "w-auto h-auto",
                            width: 10,
                            height: 10,
                            alt: "support",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        className: "text-2xl font-bold mb-2",
                        children: [
                            "? ",
                            title
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-2",
                        children: description
                    })
                ]
            }),
            title === "Chat with Us" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_use_intercom__WEBPACK_IMPORTED_MODULE_7__/* .IntercomProvider */ .H, {
                appId: INTERCOM_APP_ID,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InterCom, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: ()=>window.open(buttonLink, "_blank"),
                className: "w-full text-sm font-medium border-2 border-[#9C6CFF] hover:bg-[#9C6CFF] hover:text-white py-1.5 rounded-lg mt-6",
                children: buttonText
            })
        ]
    });
};
const InterCom = ()=>{
    const { boot , show: show1  } = (0,react_use_intercom__WEBPACK_IMPORTED_MODULE_7__/* .useIntercom */ .o)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        boot();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: show1,
            className: "w-full text-sm font-medium border-2 border-[#9C6CFF] hover:bg-[#9C6CFF] hover:text-white py-1.5 rounded-lg mt-6",
            children: "Start a Chat"
        })
    });
};


/***/ }),

/***/ 41608:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ de; },
/* harmony export */   "o": function() { return /* binding */ pe; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ae=Object.defineProperty;var R=Object.getOwnPropertySymbols;var H=Object.prototype.hasOwnProperty,K=Object.prototype.propertyIsEnumerable;var F=(e,t,n)=>t in e?ae(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,m=(e,t)=>{for(var n in t||(t={}))H.call(t,n)&&F(e,n,t[n]);if(R)for(var n of R(t))K.call(t,n)&&F(e,n,t[n]);return e};var G=(e,t)=>{var n={};for(var c in e)H.call(e,c)&&t.indexOf(c)<0&&(n[c]=e[c]);if(e!=null&&R)for(var c of R(e))t.indexOf(c)<0&&K.call(e,c)&&(n[c]=e[c]);return n};var p=(e,t)=>{let n="[react-use-intercom]";switch(e){case"info":console.log(`${n} ${t}`);break;case"warn":console.warn(`${n} ${t}`);break;case"error":console.error(`${n} ${t}`);break;default:console.log(`${n} ${t}`);}};var h=typeof window=="undefined",A=e=>(Object.keys(e).forEach(t=>{e[t]&&typeof e[t]=="object"?A(e[t]):e[t]===void 0&&delete e[t];}),e);var se=(e,...t)=>{if(!h&&window.Intercom)return window.Intercom.apply(null,[e,...t]);p("error",`${e} Intercom instance is not initalized yet`);},s=se;var ce=react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0),P=ce;var ie=(e,t=0)=>{var n=window,c=n.Intercom;if(typeof c=="function")c("reattach_activator"),c("update",n.intercomSettings);else {var w=document,l=function(){l.c(arguments);};l.q=[],l.c=function(u){l.q.push(u);},n.Intercom=l;var f=function(){setTimeout(function(){var u=w.createElement("script");u.type="text/javascript",u.async=!0,u.src="https://widget.intercom.io/widget/"+e;var d=w.getElementsByTagName("script")[0];d.parentNode.insertBefore(u,d);},t);};document.readyState==="complete"?f():n.attachEvent?n.attachEvent("onload",f):n.addEventListener("load",f,!1);}},X=ie;var me=e=>({custom_launcher_selector:e.customLauncherSelector,alignment:e.alignment,vertical_padding:e.verticalPadding,horizontal_padding:e.horizontalPadding,hide_default_launcher:e.hideDefaultLauncher,session_duration:e.sessionDuration,action_color:e.actionColor,background_color:e.backgroundColor}),Y=e=>m({company_id:e.companyId,name:e.name,created_at:e.createdAt,plan:e.plan,monthly_spend:e.monthlySpend,user_count:e.userCount,size:e.size,website:e.website,industry:e.industry},e.customAttributes),le=e=>({type:e.type,image_url:e.imageUrl}),ue=e=>{var t;return m({email:e.email,user_id:e.userId,created_at:e.createdAt,name:e.name,phone:e.phone,last_request_at:e.lastRequestAt,unsubscribed_from_emails:e.unsubscribedFromEmails,language_override:e.languageOverride,utm_campaign:e.utmCampaign,utm_content:e.utmContent,utm_medium:e.utmMedium,utm_source:e.utmSource,utm_term:e.utmTerm,avatar:e.avatar&&le(e.avatar),user_hash:e.userHash,company:e.company&&Y(e.company),companies:(t=e.companies)==null?void 0:t.map(Y)},e.customAttributes)},b=e=>A(m(m({},me(e)),ue(e)));var de=we=>{var k=we,{appId:e,autoBoot:t=!1,autoBootProps:n,children:c,onHide:w,onShow:l,onUnreadCountChange:f,onUserEmailSupplied:u,shouldInitialize:d=!h,apiBase:v,initializeDelay:ee}=k,te=G(k,["appId","autoBoot","autoBootProps","children","onHide","onShow","onUnreadCountChange","onUserEmailSupplied","shouldInitialize","apiBase","initializeDelay"]);let g=react__WEBPACK_IMPORTED_MODULE_0__.useRef(!1),y=react__WEBPACK_IMPORTED_MODULE_0__.useRef(!1),_=Object.keys(te).filter(r=>!r.startsWith("data-"));_.length>0&&p("warn",["some invalid props were passed to IntercomProvider. ",`Please check following props: ${_.join(", ")}.`].join(""));let C=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{if(!window.Intercom&&!d){p("warn","Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");return}let i=m(m({app_id:e},v&&{api_base:v}),r&&b(r));window.intercomSettings=i,s("boot",i),g.current=!0;},[v,e,d]),[x,I]=react__WEBPACK_IMPORTED_MODULE_0__.useState(!1),oe=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{I(!1),w&&w();},[w,I]),re=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{I(!0),l&&l();},[l,I]);!h&&d&&!y.current&&(X(e,ee),s("onHide",oe),s("onShow",re),s("onUserEmailSupplied",u),f&&s("onUnreadCountChange",f),t&&C(n),y.current=!0);let a=react__WEBPACK_IMPORTED_MODULE_0__.useCallback((r,i)=>{if(!window.Intercom&&!d){p("warn","Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");return}if(!g.current){p("warn",[`"${r}" was called but Intercom has not booted yet. `,`Please call 'boot' before calling '${r}' or `,"set 'autoBoot' to true in the IntercomProvider."].join(""));return}return i()},[d]),S=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{g.current&&(s("shutdown"),delete window.intercomSettings,g.current=!1);},[]),D=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{g.current&&(s("shutdown"),delete window.Intercom,delete window.intercomSettings,g.current=!1);},[]),M=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("update",()=>{let r=Math.floor(new Date().getTime()/1e3);s("update",{last_request_at:r});});},[a]),E=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{a("update",()=>{if(!r){M();return}let i=b(r);window.intercomSettings=m(m({},window.intercomSettings),i),s("update",i);});},[a,M]),T=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("hide",()=>{s("hide");});},[a]),$=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("show",()=>s("show"));},[a]),N=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("showMessages",()=>{s("showMessages");});},[a]),V=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{a("showNewMessage",()=>{r?s("showNewMessage",r):s("showNewMessage");});},[a]),z=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>a("getVisitorId",()=>s("getVisitorId")),[a]),L=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{a("startTour",()=>{s("startTour",r);});},[a]),q=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{a("startChecklist",()=>{s("startChecklist",r);});},[a]),O=react__WEBPACK_IMPORTED_MODULE_0__.useCallback((r,i)=>{a("trackEvent",()=>{i?s("trackEvent",r,i):s("trackEvent",r);});},[a]),B=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>a("showArticle",()=>{s("showArticle",r);}),[a]),U=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>a("showSpace",()=>{s("showSpace",r);}),[a]),W=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>{a("startSurvey",()=>{s("startSurvey",r);});},[a]),j=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(r=>a("showNews",()=>{s("showNews",r);}),[a]),ne=react__WEBPACK_IMPORTED_MODULE_0__.useMemo(()=>({boot:C,shutdown:S,hardShutdown:D,update:E,hide:T,show:$,isOpen:x,showMessages:N,showNewMessage:V,getVisitorId:z,startTour:L,startChecklist:q,trackEvent:O,showArticle:B,startSurvey:W,showSpace:U,showNews:j}),[C,S,D,E,T,$,x,N,V,z,L,q,O,B,W,U,j]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(P.Provider,{value:ne},c)},Z=()=>{let e=react__WEBPACK_IMPORTED_MODULE_0__.useContext(P);if(e===void 0)throw new Error('"useIntercom" must be used within `IntercomProvider`.');return e};var pe=()=>Z();


//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map

/***/ })

}]);